function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable complexity */

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { MERCHANT_CREDENTIALS_CREATE_FAIL, MERCHANT_CREDENTIALS_CREATE_REQUEST, MERCHANT_CREDENTIALS_CREATE_SUCCESS, MERCHANT_CREDENTIALS_DECRYPT_FAIL, MERCHANT_CREDENTIALS_DECRYPT_REQUEST, MERCHANT_CREDENTIALS_DECRYPT_SUCCESS, MERCHANT_CREDENTIALS_REQUEST, MERCHANT_CREDENTIALS_REQUEST_FAIL, MERCHANT_CREDENTIALS_REQUEST_SUCCESS, MERCHANT_CREDENTIALS_UPDATE_FAIL, MERCHANT_CREDENTIALS_UPDATE_REQUEST, MERCHANT_CREDENTIALS_UPDATE_SUCCESS } from '@engine/actions/action-types';
/**
 * Initial state
 */

var INITIAL_STATE = {
  hasError: false,
  isUpdating: false,
  theme: null
};
/**
 * Reducer
 */

function merchantCredentialsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case MERCHANT_CREDENTIALS_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: false,
        isUpdating: true
      });

    case MERCHANT_CREDENTIALS_REQUEST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.data.error,
        isUpdating: false,
        credentials: action.data.credentials
      });

    case MERCHANT_CREDENTIALS_REQUEST_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: true,
        isUpdating: false
      });

    case MERCHANT_CREDENTIALS_UPDATE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: false,
        isUpdating: true,
        message: null
      });

    case MERCHANT_CREDENTIALS_UPDATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.data.error,
        isUpdating: false,
        credentials: state.credentials.map(function (credential) {
          if (credential.id === action.data.credential.id) {
            return _objectSpread(_objectSpread({}, credential), {}, {
              enabled: action.data.credential.enabled
            });
          }

          return credential;
        })
      });

    case MERCHANT_CREDENTIALS_UPDATE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: true,
        isUpdating: false,
        message: action.data.message
      });

    case MERCHANT_CREDENTIALS_CREATE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: false,
        isUpdating: true,
        message: null
      });

    case MERCHANT_CREDENTIALS_CREATE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.data.error,
        isUpdating: false,
        credentials: [action.data.credential].concat(_toConsumableArray(state.credentials))
      });

    case MERCHANT_CREDENTIALS_CREATE_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: true,
        isUpdating: false,
        message: action.data.message
      });

    case MERCHANT_CREDENTIALS_DECRYPT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: false,
        isUpdating: true,
        message: null
      });

    case MERCHANT_CREDENTIALS_DECRYPT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.data.error,
        isUpdating: false,
        credentials: state.credentials.map(function (credential) {
          if (credential.id === action.id) {
            return _objectSpread(_objectSpread({}, credential), {}, {
              password: action.data.decrypted_attribute
            });
          }

          return credential;
        })
      });

    case MERCHANT_CREDENTIALS_DECRYPT_FAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: true,
        isUpdating: false,
        message: action.data.message
      });

    default:
      return state;
  }
}

export default merchantCredentialsReducer;